import type { MarketExceptionType } from '../../MarketExceptionTypes'

export const PH: MarketExceptionType = {
  marketoSmsOptIn: true,
  signUpReCaptcha: true,
  showPasswordRequirements: true,
  subscriptionManager: {
    isShipNowDisabled: true,
  },
  signupPrivacyPolicy: {
    enabled: true,
    required: true,
  },
  checkoutTermsAndConditionsAgreementCheckbox: {
    enabled: true,
    required: false,
    displayTextOnly: true,
  },
  tax: {
    inclusive: true,
    noFrontendTaxCalculation: true,
    explicitlyExclusive: false,
  },
  checkoutTermsAndConditionsStatement: false,
  currencyCode: 'PHP',
  creditCardProvidersSupported: ['MC', 'VI', 'AX', 'DI'],
  isWorldPay3DS: false,
  poboxRestricted: false,
  hasGCash3DS: true,
  isPickupMarket: true,
  hasAddressRegion: true,
  allowShippingToExternalCountries: false,
  supportsStoreCredit: true,
  hasNativeCreditCard: false,
  hasIPay88CreditCard3DS: true,
  disableMixedOrders: true,
  subscriptionPaymentWithOrdersCallOnly: true,
  shippingMethodRestrictions: [
    {
      shippingMethodType: 'SameDay',
      restrictions: {
        city: [
          'Pasig',
          'Muntinlupa',
          'Taguig',
          'Makati',
          'Mandaluyong',
          'Marikina',
          'Quezon City',
          'Pasay',
          'San Juan',
          'Taguig City',
          'Pateros',
          'Muntinlupa City',
          'Makati City',
          'Mandaluyong City',
          'Marikina City',
          'Pasay City',
          'Quezon City North',
          'Pasig City',
          'Las Piñas City',
          'Las Piñas',
          'Parañaque City',
          'Parañaque',
          'Manila',
        ],
        region: null,
        allowedForSubscriptions: false,
      },
    },
  ],

  applePayOTP: false,
  applePaySubscriptions: false,
  hasPaypal: false,
  hasPaypal3DS: false,
  hasShipByDate: false,
  hasAddressValidation: false,
  allowSubscriptionPickup: false,
  hasProductAvailability: true,
  hasZipCode: true,
  skuAvailabilityShippingMethod: 'Economy',
  defaultEconomyShippingMethod: 'Economy',
  restrictedPickupLocations: [],
  reportIssueButton: {
    show: true,
    url: {
      en: 'https://docs.google.com/forms/d/e/1FAIpQLSdcZcY3ldjKKOhDQ0Vfhy1clTfBcwBHD4I5bstWhCjY2Kan8A/viewform?usp=sharing&ouid=113588036243803257850',
    },
  },
  skuPricingOverrides: ['34936', '36073'],
  omitSubscriptionsAppWide: false,
}
